import Section from "./Section";
import { Box, Button, Container, Divider, Typography } from "@mui/material";

function ErrorTopLevel() {
  return (
    <Section size="large">
      <Container maxWidth="sm">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={2}
        >
          <Typography
            component="p"
            sx={{
              fontSize: { xs: "5rem", sm: "7rem" },
              fontWeight: 700,
              lineHeight: 1,
              letterSpacing: "-0.04em",
              color: "error.main",
              userSelect: "none",
            }}
          >
            Oops
          </Typography>

          <Box>
            <Typography
              variant="h5"
              sx={{ fontWeight: 600, color: "text.primary", mb: 0.5 }}
            >
              Something Went Wrong
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", maxWidth: 340 }}
            >
              An unexpected error occurred. Please reload the page or return
              home.
            </Typography>
          </Box>

          <Divider sx={{ width: "100%", borderColor: "divider" }} />

          <Button variant="contained" href="/" size="small" disableElevation>
            Home
          </Button>
        </Box>
      </Container>
    </Section>
  );
}

export default ErrorTopLevel;
